import initWxShare from '@/utils/initWxShare'
import deepClone from '@/utils/deepClone'
// import router from "@/router"

// const TAB_AREA_KEY = "AREA"
// const POPULARITY_KEY = "POPULARITY"
// const LATEST_RELEASE_KEY = "LATEST_RELEASE"
// const RECOMMEND_KEY = "RECOMMEND"
// const WORKS_TYPE_KEY = "WORKSTYPE"

export default {
  namespaced: true,
  state: {
    activityId: '',
    shareInfo: {
      title: ' ',
      desc: '“南方+”创造更多价值！',
      link: window.location.href,
      imgUrl: 'https://static.nfapp.southcn.com/app/nanfang_logo.png'
    },
    activityInfo: null
  },
  getters: {
    activityId: state => state.activityId,
    activityInfo: state => state.activityInfo,
    shareInfo: state => state.shareInfo
  },
  mutations: {
    setShareInfo (state, shareInfo) {
      state.shareInfo = Object.assign({}, state.shareInfo, shareInfo)
    },
    setActivityInfo (state, activityInfo) {
      state.activityInfo = Object.assign({}, state.activityInfo, activityInfo)
    },
    setActivityId (state, activityId) {
      state.activityId = activityId
    }
  },
  actions: {
    initWxShare ({ rootState }) {
      const isWx = rootState.systemInfo.isWx
      if (!isWx) return
      const shareOptions = { ...rootState.activityInfo.shareInfo }
      initWxShare(shareOptions)
    },
    initNfPluseShare ({ rootState }) {
      const isNfPlus = rootState.systemInfo.isNfPlus
      const shareInfo = rootState.activityInfo.shareInfo
      if (!isNfPlus) return
      try {
        if (window.nfplusJsbridge) {
          const version = window.nfplusJsbridge.getInsideVersion()
          window.console.log({ version })
          if (version && version < 660) {
            window.nfplusJsbridge.needUpgrade() // 版本低于660，调用更新提示
          } else {
            window.nfplusJsbridge.setShareInfo({
              title: shareInfo.title,
              content: shareInfo.desc,
              icon: shareInfo.imgUrl,
              url: shareInfo.link
            })
          }
        }
      } catch (error) {
        window.console.error(error)
      }
    },
    initShareInfo ({ dispatch }) {
      dispatch('initWxShare')
      dispatch('initNfPluseShare')
    }
  }
}
